import { Apple, Download, Smartphone } from "lucide-react";
import AdminShell from "@/components/admin/AdminShell";
import StatCard from "@/components/admin/StatCard";
import { useT } from "@/i18n/LanguageContext";

export default function AdminDownloads() {
  const { t } = useT();
  return (
    <AdminShell title={t("admin.downloads.title")}>
      <p className="text-sm text-bone/60 -mt-6 mb-8 max-w-2xl">
        {t("admin.downloads.intro")}
      </p>

      <section className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10" data-testid="downloads-kpis">
        <StatCard testId="dl-total"   icon={Download}   label={t("admin.downloads.total")}   value="—" hint={t("admin.label.lifetime")} accent="fog" />
        <StatCard testId="dl-week"    icon={Download}   label={t("admin.downloads.week")}    value="—" hint={t("admin.label.rollingWeek")} accent="fog" />
        <StatCard testId="dl-ios"     icon={Apple}      label={t("admin.downloads.ios")}     value="—" hint="App Store" accent="fog" />
        <StatCard testId="dl-android" icon={Smartphone} label={t("admin.downloads.android")} value="—" hint="Play Store" accent="fog" />
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="downloads-stores">
        <div className="border border-gold/15 bg-white/[0.02] p-6">
          <div className="flex items-center gap-3 mb-4">
            <Apple size={16} strokeWidth={1.5} className="text-gold" />
            <h3 className="font-serif text-lg text-bone">App Store</h3>
          </div>
          <p className="text-sm text-bone/60 mb-4">{t("admin.downloads.appstoreLive")}</p>
          <div className="flex items-center justify-between text-[13px]">
            <span className="text-bone/60">{t("admin.downloads.version")}</span><span className="text-bone/85">1.0.0</span>
          </div>
          <div className="flex items-center justify-between text-[13px] mt-2">
            <span className="text-bone/60">{t("admin.downloads.lastRelease")}</span><span className="text-bone/85">—</span>
          </div>
        </div>

        <div className="border border-gold/15 bg-white/[0.02] p-6">
          <div className="flex items-center gap-3 mb-4">
            <Smartphone size={16} strokeWidth={1.5} className="text-gold" />
            <h3 className="font-serif text-lg text-bone">Play Store</h3>
          </div>
          <p className="text-sm text-bone/60 mb-4">{t("admin.downloads.playSoon")}</p>
          <div className="flex items-center justify-between text-[13px]">
            <span className="text-bone/60">{t("admin.downloads.version")}</span><span className="text-bone/85">1.0.0</span>
          </div>
        </div>
      </section>
    </AdminShell>
  );
}
